import translator from '@Components/Utilities/Translator';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';

const ReturnsAndRefundsView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.PageTitle}</h1>
            </div>
            <div className='returns-and-refunds-container'>
                <p align='left'>
                    {translator.translate('Sandhills.TradeSites.MVC.TheReturnAndRefundPolicyForEach', [props.PublicationSite])}&nbsp;
                    {translator.translate('Sandhills.TradeSites.MVC.DoesNotManageTheReturns', [props.PublicationSite])}&nbsp;
                    {translator.translate('Sandhills.TradeSites.MVC.PleaseReferToTheSellerForDetails')}&nbsp;
                    {translator.translate('Sandhills.TradeSites.MVC.TheSellerForEachItemListedOnOurWebsite')}&nbsp;
                </p>
            </div>
        </div>
    );
};

export default ReturnsAndRefundsView;
global.ReturnsAndRefundsView = ReturnsAndRefundsView;